import CRUDActions from './CRUD';
import {VideoCategory} from '../api/video_category';

export class VideoCategoryActions extends CRUDActions {
  prefix = 'video-categories';

  get _model() {
    return VideoCategory;
  }
}

export const videoCategoriesActions = new VideoCategoryActions();



// WEBPACK FOOTER //
// ./src/actions/video-categories.ts